import { removeUndefined } from '@helpers/object';

/**
 * @typedef MessageStatusApiPayload
 * @prop {string} messageThreadId Thread ID
 * @prop {boolean} [read] Message read status
 * @prop {boolean} [archived] Message archived status
 */

/**
 * @typedef MessageStatusApiRequest
 * @prop {string} message_thread Thread ID
 * @prop {boolean} [read] Message read status
 * @prop {boolean} [archived] Message archived status
 */

/**
 * Prepare API request payload data for message status update
 * @param {MessageStatusApiPayload} payload Request payload
 * @returns {MessageStatusApiRequest} Transformed request data
 */
export const messageStatusSetModel = (payload = {}) =>
  removeUndefined({
    message_thread: payload.messageThreadId,
    read: payload.read,
    archived: payload.archived,
  });
